import { render } from "./LinksRapidos.vue?vue&type=template&id=a07ccf4c"
import script from "./LinksRapidos.vue?vue&type=script&lang=js"
export * from "./LinksRapidos.vue?vue&type=script&lang=js"

import "./LinksRapidos.vue?vue&type=style&index=0&id=a07ccf4c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__